<template>
    <v-dialog v-model="dialog" scrollable persistent max-width="600px" fullscreen transition="dialog-bottom-transition">
        <template v-slot:activator="{ on }">
            <div class="text-left">
                <v-btn block tile class="text-left" color="#f7d9cd" v-on="on" style="box-shadow: none;">
                        <span class="primary--text">
                            {{$t('prestacionales')}}
                            <v-tooltip bottom max-width="500">
                                <template v-slot:activator="{on}">
                                    <v-icon v-on="on">mdi-information-outline</v-icon>
                                </template>
                                <span>En este apartado se muestran los datos técnicos del material de revestimiento evaluado. Se trata de características personalizables que el usuario puede modificar.</span>
                            </v-tooltip>
                        </span>
                    <v-spacer></v-spacer>
                </v-btn>
            </div>
        </template>
        <v-card class="primary--text">
            <v-card-title class="pt-2 pb-1 pl-2 pr-1 font-weight-bold title primary white--text">
                {{$t('prestacionales_descrip')}}
                <v-spacer></v-spacer>
                <v-btn icon right @click="cerrar" color="white">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="6" v-for="i in [0,1]" :key="i">
                            <listado-prestacionales-componente :solucion-constructiva="solucionesConstructivas[i]">
                            </listado-prestacionales-componente>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <div class="flex-grow-1"></div>
                <v-btn color="error" text @click="restaurar()">{{$t('restaurar_todo')}}</v-btn>
                <v-btn color="secondary" text @click="dialog = false">{{$t('cerrar') | capitalize}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import ListadoPrestacionalesComponente from "./ListadoPrestacionalesComponente/ListadoPrestacionalesComponente";

    export default {
        name: "DeclaracionAmbientalComponente",
        props: {
            solucionesConstructivas: {type: Array, required: true},
        },
        data: () => ({
            dialog: false,
        }),
        components: {
            ListadoPrestacionalesComponente
        },
        mounted() {
        },
        methods: {
            cerrar() {
                this.dialog = false;
            },
            restaurar() {
                this.solucionesConstructivas.forEach((solCons) => {
                    if (solCons.prestacionDermis == null)
                        solCons.prestacionDermis = {parametros: {}};
                    else
                        solCons.prestacionDermis.parametros = {};
                });
            }
        }
    }
</script>

<style scoped>

</style>

<!--@formatter:off-->
<i18n>
    {
    "es": {
    "prestacionales": "Características técnicas",
    "prestacionales_descrip":"Personalización indicadores prestacionales",
    "descrip_paso":"En esta sección se debe definir las características del proyecto",
    "cerrar":"Cerrar",
    "restaurar_todo":"Restaurar todo"
    }
    }
</i18n>
<!--@formatter:on-->